<template>
  <div class="d2-notificationComp ">
    <div class="d2-notificationComp__head">
      <h3 class="d2-h3">{{ $t("notification") }}</h3>
    </div>
    <ul>
      <li v-for="item in notification_gamebox" :key="item.key">
        <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(item.id)">
          <div class="d2-notificationComp__img">
            <img :src="item.thumbnail_url"/>
          </div>
          <div class="d2-notificationComp__content">
            <!-- <h2 class="mobiTitle sm">{{item.cont_name_english}}</h2> -->
            <span v-if="lang_gamebox !== 'english'">
              <h4 class="d2-h4" v-if="item[`cont_name_${lang_gamebox}`] !== ''">{{ item[`cont_name_${lang_gamebox}`] }}</h4>
              <h4 class="d2-h4" v-else>{{ item[`cont_name_english`] }}</h4>
            </span>
            <span v-else>
              <h4 class="d2-h4">{{ item[`cont_name_english`] }}</h4>
            </span>
            <!-- <p class="mobilabel">{{item.titleSub_english}}</p> -->
            <p class="d2-label">{{ item[`titleSub_${lang_gamebox}`] }}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["notification_gamebox", "lang_gamebox", "country_gamebox"])
  },
  created() {
    this.fetchNotification_gamebox();
  },
  methods: {
    ...mapActions(["fetchNotification_gamebox"]),
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  }
};
</script>

<style scoped lang="scss">
.d2-notificationComp {
  background: #fff;
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  ul {
    list-style: none;
    padding: 0;
  }

  a {
    display: flex;
    color: #000;
    text-decoration: none;
    padding: 15px;
  }
  img {
    width: 100%;
  }
  .d2__inner.app {
    background-color: transparent;
    cursor: pointer;
  }
  .d2__inner:hover {
    color: #000;
  }
}
.d2-notificationComp__head {
  padding: 8px 15px;
  .d2-h3 {
    color: #000;
  }
}
.d2-notificationComp__content {
  padding-left: 8px;
}
.d2-notificationComp__img {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
}
.ar_layout {
  .d2-notificationComp__content {
    padding-left: 0;
    padding-right: 8px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Notification.vue